/*
export function someMutation (state) {
}
*/

export function SET_CONTA_CORRENTE(state, obj) {
  state.contaBancaria = obj;
}
